import React from 'react';
import Header from '../Header/Header';
import Table from '../Table/Table';
import Navigation from '../Navigation/Navigation';
import { connect } from 'react-redux';
import { fetchCustomerProjectsFromMendix, fetchAllHolidays } from "../../actions/CustomerActions";
import { logout } from "../../actions/AuthActions";
import { fetchMendixUser } from "../../actions/UserActions";

import HolidayList from "../HolidayList/HolidayList";

class Layout extends React.Component {

    constructor(props) {
        super(props);

        this.table = React.createRef();

        const result = Table.getWeekNumber(new Date());

        this.state = {
            showWeekend: false,
            query: { week: result[1], year: result[0] },
            search: "",
            showAllHolidays: false
        };
    }

    async componentDidMount() {
        await this.props.fetchMendixUser();

        const week = this.state.query.week;
        const year = this.state.query.year;

        await this.props.fetchCustomerProjectsFromMendix(week, year);
        await this.props.fetchAllHolidays(week, year);
    }

    componentDidUpdate(prevProps, prevState) {
        const week = this.state.query.week;
        const year = this.state.query.year;

        if (
            prevState.query.week !== week ||
            prevState.query.year !== year
        ) {
            this.props.fetchCustomerProjectsFromMendix(week, year);
            this.props.fetchAllHolidays(week, year);
        }
    }

    toggleWeekend = () => {
        this.setState({ showWeekend: !this.state.showWeekend });
    };

    toggleAllHolidays = () => {
        const newState = !this.state.showAllHolidays;

        this.setState({ showAllHolidays: newState });

        if (newState === true) {
            const week = this.state.query.week;
            const year = this.state.query.year;
            this.props.fetchAllHolidays(week, year);
        }
    };

    search = (event) => {
        this.setState({ search: event.currentTarget.value });
    };


	getWeeksInYear(year) {
		return Table.getWeekNumber(new Date(year, 11, 28))[1];
	}

    getDateOfISOWeek(week, year) {
        var simple = new Date(year, 0, 1 + (week - 1) * 7);
        var dayOfWeek = simple.getDay();
        var isoWeekStart = new Date(simple);

        if (dayOfWeek <= 4 && dayOfWeek !== 0) {
            isoWeekStart.setDate(simple.getDate() - dayOfWeek + 1);
        } else if (dayOfWeek === 0) {
            isoWeekStart.setDate(simple.getDate() - 6);
        } else {
            isoWeekStart.setDate(simple.getDate() + 8 - dayOfWeek);
        }

        return isoWeekStart;
    }

    previousWeek = () => {
        const week = this.state.query.week;
        const year = this.state.query.year;

        let newWeek = week - 1;
        let newYear = year;

        if (newWeek < 1) {
            newYear = year - 1;
            newWeek = this.getWeeksInYear(newYear);
        }

        this.setState({ query: { week: newWeek, year: newYear } });
    };

    nextWeek = () => {
        const week = this.state.query.week;
        const year = this.state.query.year;

        const weeksInYear = this.getWeeksInYear(year);

        let newWeek = week + 1;
        let newYear = year;

        if (newWeek > weeksInYear) {
            newYear = year + 1;
            newWeek = 1;
        }

        this.setState({ query: { week: newWeek, year: newYear } });
    };

    now = () => {
        const result = Table.getWeekNumber(new Date());
        this.setState({ query: { week: result[1], year: result[0] } });
    };

    datePick = (date) => {
        const result = Table.getWeekNumber(date);
        this.setState({ query: { week: result[1], year: result[0] } });
    };

    getDays() {
        const week = this.state.query.week;
        const year = this.state.query.year;

        const monday = this.getDateOfISOWeek(week, year);
        const days = [];

        for (let i = 0; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            days.push(day);
        }

        return days;
    }

    render() {
        console.log("USER PASSED TO HOLIDAYLIST:", this.props.user);

        const days = this.getDays();
        const weekdaysOnly = days.filter(function (d) {
            const day = d.getDay();
            return day !== 0 && day !== 6;
        });

        return (
            <div>
                <Header
                    key={this.props.user ? "header-" + this.props.user.email : "header-null"}
                    location={this.props.location}
                    search={this.search}
                    toggleWeekend={this.toggleWeekend}
                    toggleAllHolidays={this.toggleAllHolidays}
                    week={this.state.query.week}
                    year={this.state.query.year}
                    previousWeek={this.previousWeek}
                    nextWeek={this.nextWeek}
                    showAllHolidays={this.state.showAllHolidays}
                    user={this.props.user}
                />

                <nav className="m-t-xs">
                    <div className="container">
                        <div className="navigation-container">
                            <Navigation
                                toggleWeekend={this.toggleWeekend}
                                previousWeek={this.previousWeek}
                                nextWeek={this.nextWeek}
                                now={this.now}
                                datePick={this.datePick}
                                week={this.state.query.week}
                                year={this.state.query.year}
                                toggleAllHolidays={this.toggleAllHolidays}
                            />
                        </div>
                        <div className="clearFix" />
                    </div>
                </nav>

                <main className="main-content m-t-xs">
                    <div className="container">
                        <div className="card">
                            {this.state.showAllHolidays ? (
                                <HolidayList
                                    rawHolidays={this.props.holidays}
                                    days={weekdaysOnly}
                                    user={this.props.user}
                                    week={this.state.query.week}
                                    updatedHolidaySaldo={false}
                                />
                            ) : (
                                <Table
                                    customers={this.props.customers.customers || []}
                                    ref={this.table}
                                    key={"table-" + this.state.query.week + "-" + this.state.query.year}
                                    search={this.state.search}
                                    showWeekend={this.state.showWeekend}
                                    week={this.state.query.week}
                                    year={this.state.query.year}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        customers: state.customers,
        holidays: state.holidays,
        user: state.user.mendixUser
    };
}

export default connect(
    mapStateToProps,
    { fetchCustomerProjectsFromMendix, fetchAllHolidays, fetchMendixUser, logout }
)(Layout);